import { Center } from '@chakra-ui/react'
import React from 'react'
import { responsive } from '../contexts/responsive'

const CenterContainer = (props) => {
  return (
    <Center
      maxW={'35.125em'}
      width="100%"
      mx={'auto'}
      position={'relative'}
      bg={'black'}
      overflow={'hidden'}
      p="2em 2em 3.875em 2em"
      flexDirection={'column'}
      {...props}
    />
  )
}

export default CenterContainer
